module.exports = __webpack_public_path__ + "static/img/bg_radio.c607e110.png";